import {
  Card,
  CardBody,
  Heading,
  HStack,
  Icon,
  IconButton,
  List,
  ListItem,
  VStack,
} from "@chakra-ui/react";
import { useSuspenseQuery } from "@tanstack/react-query";
import { listingsModel } from "models/listings";
import { useNavigate, useParams } from "react-router-dom";
import BackArrowIcon from "assets/icons/medium/back-arrow.svg?react";
import { ScreenWrapper } from "components/screen-wrapper";
import { FeedbackListItem } from "modules/vendor-portal/screens/overview/components/feedback/feedback-list-item";

export function AgentUpdatesScreen() {
  const { propertyId } = useParams();
  const { data } = useSuspenseQuery(listingsModel.queries.read(propertyId));
  const navigate = useNavigate();
  const agentUpdates = data?.agent_updates?.entries ?? [];

  return (
    <ScreenWrapper>
      <VStack gap={3} mb={8} alignItems={"stretch"}>
        <HStack gap={2}>
          <IconButton
            aria-label={"Back"}
            variant={"ghost"}
            icon={<Icon as={BackArrowIcon} boxSize={"16px"} />}
            color={"#000"}
            cursor={"pointer"}
            onClick={() => navigate(-1)}
          />

          <Heading fontSize={"20px"} fontWeight={700} color={"gray.700"}>
            Agent Updates
          </Heading>
        </HStack>

        <List>
          {agentUpdates?.map((update) => (
            <ListItem key={update.id} pt={3} pr={10} pb={4} pl={3}>
              <Card>
                <CardBody>
                  <FeedbackListItem feedback={update} />
                </CardBody>
              </Card>
            </ListItem>
          ))}
        </List>
      </VStack>
    </ScreenWrapper>
  );
}
